import {
  Field,
  Input,
  makeStyles,
  shorthands,
} from "@fluentui/react-components";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import moment from "moment";
import CreatableSelect from "react-select/creatable";
import React, { ChangeEvent } from "react";
import { DismissFilled } from "@fluentui/react-icons";
import DynamicDatePicker from "../../../components/ControlledDatePicker/dynamicDatepicker";

function onFormatDate(date: Date | undefined) {
  return !date ? "" : moment(date).format("DD-MM-YYYY");
}

export const useStyles = makeStyles({
  btn_mode: { marginLeft: "3px", marginRight: "3px" },
  btnwrapper: {
    columnGap: "8px",
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "6px",
    marginTop: "6px",
  },
  buttonWrapper: {
    columnGap: "15px",
    display: "flex",
    ...shorthands.padding("10px"),
  },
  containerTopArea: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  message: { marginRight: "14px" },
});

const selectStyles: any = {
  control: (baseStyles: any, state: any) => ({
    ...baseStyles,
    border: "none",
    borderColor: state.isFocused ? "grey" : "grey",
    padding: "0px",
    minHeight: "32px !important",
    height: "32px",
    alignItems: "baseline",
  }),
  input: (base: any) => ({ ...base, overflow: "auto" }),
  indicatorsContainer: (base: any) => ({ ...base, height: "32px" }),
};

export const ElementData = ({
  element,
  formik,
  selectFieldOptions,
  newItemAdded,
  selectionListNewItems,
  handleOnChange,
}: any) => {
  const getOptions = (field: string) => {
    const fieldData = selectFieldOptions.find(
      (item: any) => item.field === field
    );
    if (fieldData) {
      return fieldData.options.filter(
        (option: any, index: number, self: any) =>
          index === self.findIndex((t: any) => t.value === option.value)
      );
    }
    return [];
  };

  const handleSelectChange = (selectedOption: any, fieldName: string) => {
    const value = selectedOption ? selectedOption.value : "";
    formik.setFieldValue(fieldName, value, true); // Trigger validation
    handleOnChange?.(fieldName, value);
    newItemAdded(
      selectedOption || { value: "", label: "" },
      fieldName,
      selectedOption ? "add" : "remove"
    );
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    formik.setFieldValue(name, value, true); // Trigger validation
    handleOnChange?.(name, value);
  };

  const handleClearDate = () => {
    formik.setFieldValue(element.name, null, true); // Trigger validation
    handleOnChange?.(element.name, null);
  };

  switch (element.type) {
    case 0: {
      const fieldValue = formik.values[element.name] ?? "";
      const selectValue = selectionListNewItems[element.name] ?? {
        value: "",
        label: "",
      };
      const errorMessage = formik.errors[element.name];

      return (
        <Field
          key={element.id}
          label={element.name}
          className="field-pading"
          validationState={errorMessage ? "error" : "none"}
          validationMessage={errorMessage || ""}
        >
          <CreatableSelect
            styles={selectStyles}
            isClearable
            name={element.name}
            value={selectValue}
            onChange={(option) => handleSelectChange(option, element.name)}
            getOptionLabel={(option: any) => option.value}
            options={getOptions(element.name)}
          />
        </Field>
      );
    }
    case 3: {
      return (
        <DynamicDatePicker
          key={element.id}
          name={element.name}
          label={element.name}
          required={false}
          disabled={false}
          formik={{
            values: {
              [element.name]: formik?.values[element.name]
                ? new Date(formik.values[element.name])
                : null,
            },
            setFieldValue: (_name: string, value: Date | null) => {
              formik.setFieldValue(element.name, value, true);
              handleOnChange?.(element.name, value);
            },
            setFieldTouched: formik.setFieldTouched,
            setFieldError: formik.setFieldError,
            errors: formik.errors,
            touched: formik.touched,
          }}
        />
      );
    }
    default: {
      const fieldValue = formik.values[element.name] ?? "";
      const errorMessage = formik.errors[element.name];

      return (
        <Field
          key={element.id}
          label={element.name}
          className="field-pading"
          validationState={errorMessage ? "error" : "none"}
          validationMessage={errorMessage || ""}
        >
          <Input
            appearance="filled-lighter"
            name={element.name}
            onBlur={formik.handleBlur}
            value={fieldValue}
            onChange={handleInputChange}
            type="number"
          />
        </Field>
      );
    }
  }
};
